<div class="flex flex-row gap-2 p-4">
  <p-select [options]="viewOptions" [ngModel]="finalView()" (onChange)="onModeChange($event)"></p-select>
  <input pInputText [ngModel]="search()" (ngModelChange)="onSearchChange($event)" placeholder="Search"/>
  <p-select [options]="fuzzinessOptions" [ngModel]="fuzziness()" (ngModelChange)="onFuzzinessChange($event)" placeholder="Fuzziness"></p-select>
  <p-button (onClick)="openById()" icon="pi pi-user" label="Open by ID"></p-button>
  <input pInputText [ngModel]="emailSearch()" (ngModelChange)="emailSearch.set($event)" placeholder="Exact email search" (keydown.enter)="searchByEmail()"/>
  <p-button (onClick)="searchByEmail()" icon="pi pi-search" label="Search email" [loading]="emailSearchLoading()"></p-button>
  <input pInputText [ngModel]="phoneSearch()" (ngModelChange)="phoneSearch.set($event)" placeholder="Search by phone" (keydown.enter)="searchByPhone()"/>
  <p-button (onClick)="searchByPhone()" icon="pi pi-search" label="Search phone" [loading]="phoneSearchLoading()"></p-button>
</div>

<div class="flex flex-row gap-2 mt-2 mb-4 align-items-center px-4">
  @if (loading()) {
    <span>Loading...</span>
  } @else {
    <span>Showing {{ users().length }} of {{ totalCount() }} users</span>
  }
</div>

<p-table [value]="users()"
         [scrollable]="true" scrollHeight="65vh"
         [virtualScroll]="true" [virtualScrollItemSize]="48">
  <ng-template pTemplate="header">
    <tr>
      <th>Id</th>
      <th>Created at</th>
      <th>Name</th>
      <th>Email</th>
      <th>Assistance</th>
      <th>Last seen</th>
      <th>Payment</th>
      <th>Status</th>
      <th>Sync</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user [homeyTypedTableRow]="users()">
    <tr>
      <td>
        <homey-user-link [id]="user.id"/>
      </td>
      <td>{{ user.createdAt | date:'M/d/yy, h:mm a' }}</td>
      <td>{{ user.firstName }} {{ user.lastName }}</td>
      <td>{{ user.email }}</td>
      <td>{{ user.rentalAssistance }}</td>
      <td>{{ user.lastSeen | date:'M/d/yy, h:mm a' }}</td>
      <td>
        <p-tag [severity]="paymentStatusToTag(user.paymentStatus)">{{ user.paymentStatus }}</p-tag>
      </td>
      <td>
        <p-tag [severity]="homeyStatusToTag(user.status)">{{ user.status }}</p-tag>
      </td>
      <td>
        @if (user.lastSyncStatus === 'sync-failed') {
          <p-tag severity="danger" [pTooltip]="user.lastSyncError ?? ''" tooltipPosition="left">FAILED</p-tag>
        } @else if (user.lastSyncError) {
          <p-tag severity="warn" [pTooltip]="user.lastSyncError" tooltipPosition="left">ERROR</p-tag>
        }
      </td>
      <td>
        @if (user.ignore) {
          <p-tag severity="danger">IGNORED</p-tag>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
